






































import {
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import GuardarButton from '@/reusable/Modal/GuardarButton.vue';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { ScriptValidacion } from '@/interfaces/ContratoProveedor';

@Component({
  components: {
    CabeceraModal,
    GuardarButton,
    ContenidoModal,
    ModalMantenedor,
    FormFieldsContainer,
  },
})
export default class CrearCabeceraHttpModal extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: false }) modoEditar: boolean;
  @Prop() cabeceraSeleccionada: ScriptValidacion;

  formFields: FormFieldDefMap = {
    nombre: {
      label: 'Nombre',
      id: 'nombre',
      value: '',
    },
    valor: {
      label: 'Valor',
      id: 'valor',
      value: '',
    },
  };

  mounted() {
    this.$validator.localize('es', makeValidatorDictionary(this.formFields));
  }

  @Watch('cabeceraSeleccionada', { deep: true })
  handleCabeceraSeleccionadaChange() {
    if (this.cabeceraSeleccionada) {
      this.formFields.nombre.value = this.cabeceraSeleccionada.nombre;
      this.formFields.valor.value = this.cabeceraSeleccionada.script;
    }
  }

  handleCerrar() {
    this.formFields.nombre.value = '';
    this.formFields.valor.value = '';
    this.$emit('cerrar');
  }

  async handleGuardar() {
    const isValid = await this.$validator.validateAll();

    if (isValid) {
      var cabeceraHttp: ScriptValidacion = {
        nombre: this.formFields.nombre.value.toString(),
        script: this.formFields.valor.value.toString(),
      };

      if (!this.modoEditar) {
        this.$emit('crear', cabeceraHttp);
      } else {
        this.$emit('editar', cabeceraHttp);
      }

      this.handleCerrar();
    }
  }
}
